<ejs-dialog
	#modal
	cssClass="modal-md"
	(close)="closeModal()"
	[attr.data-test-id]="'practicePayPaymentModal'">
	<ng-template #header>
		<div class="dlg-template">Process Payment</div>
	</ng-template>
	<ng-template #content>
		@if (errors.length) {
			<div class="alert alert-danger">
				<ul>
					@for (error of errors; track error) {
						<li><strong>{{ error }}</strong></li>
					}
				</ul>
			</div>
		}
		@if (isLoading || isProcessing) {
			<div class="text-center padding-md">
				<i class="fa fa-spinner fa-spin fa-2x"></i>
				@if (isLoading) {
					<p class="margin-top-sm">Loading secure payment form...</p>
				}
				@if (isProcessing) {
					<p class="margin-top-sm">Processing payment...</p>
				}
			</div>
		}
		@if (iframeUrl && !isLoading && !isProcessing) {
			<div class="practice-pay-iframe-container">
				<iframe
					[src]="iframeUrl"
					(load)="onIframeLoad()"
					class="practice-pay-iframe"
					[attr.data-test-id]="'practicePayPaymentIframe'">
				</iframe>
			</div>
		}
	</ng-template>
	<ng-template #footerTemplate>
		@if (!isProcessing) {
			<button ejs-button cssClass="e-link pull-left margin-left-0" (click)="applyPaymentWithoutProcessingCard()"
					[attr.data-test-id]="'applyPaymentWithoutProcessingCardButton'">Apply payment without processing card
			</button>
		}
		<button ejs-button iconCss="fa fa-times" type="button" (click)="closeModal()"
				[disabled]="isProcessing"
				[attr.data-test-id]="'practicePayPaymentCancelButton'">Cancel
		</button>
	</ng-template>
</ejs-dialog>
